import { toString, Union, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { union_type, class_type, bool_type, option_type, list_type, int32_type, record_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { empty, toList, map as map_2, ofList } from "../../fable_modules/fable-library.3.7.20/Map.js";
import { sortBy, tryHead, map } from "../../fable_modules/fable-library.3.7.20/List.js";
import { now } from "../../fable_modules/fable-library.3.7.20/Date.js";
import { defaultArg, map as map_1 } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { comparePrimitives } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { DateTimeExtensions_toIso8601 } from "../../Utils.js";
import { Json$reflection } from "../../fable_modules/Fable.SimpleJson.3.21.0/Json.fs.js";

export class KeyValue extends Record {
    constructor(Key, Value) {
        super();
        this.Key = Key;
        this.Value = Value;
    }
}

export function KeyValue$reflection() {
    return record_type("Containers.TelecomOrder.Model.KeyValue", [], KeyValue, () => [["Key", string_type], ["Value", string_type]]);
}

export class ParameterDTO extends Record {
    constructor(Description, Name, ParameterIndex, ValidValues) {
        super();
        this.Description = Description;
        this.Name = Name;
        this.ParameterIndex = (ParameterIndex | 0);
        this.ValidValues = ValidValues;
    }
}

export function ParameterDTO$reflection() {
    return record_type("Containers.TelecomOrder.Model.ParameterDTO", [], ParameterDTO, () => [["Description", string_type], ["Name", string_type], ["ParameterIndex", int32_type], ["ValidValues", option_type(list_type(KeyValue$reflection()))]]);
}

export class AvailableOperationDTO extends Record {
    constructor(AddParameters, Category, Description, Name, RemoveParameters, Status) {
        super();
        this.AddParameters = AddParameters;
        this.Category = Category;
        this.Description = Description;
        this.Name = Name;
        this.RemoveParameters = RemoveParameters;
        this.Status = Status;
    }
}

export function AvailableOperationDTO$reflection() {
    return record_type("Containers.TelecomOrder.Model.AvailableOperationDTO", [], AvailableOperationDTO, () => [["AddParameters", list_type(ParameterDTO$reflection())], ["Category", string_type], ["Description", string_type], ["Name", string_type], ["RemoveParameters", option_type(list_type(ParameterDTO$reflection()))], ["Status", string_type]]);
}

export class ParameterType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Switch", "Text", "Option"];
    }
}

export function ParameterType$reflection() {
    return union_type("Containers.TelecomOrder.Model.ParameterType", [], ParameterType, () => [[["Item", bool_type]], [["Item", string_type]], [["Item1", string_type], ["Item2", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type])]]]);
}

export class Parameter extends Record {
    constructor(Name, Index, Type) {
        super();
        this.Name = Name;
        this.Index = (Index | 0);
        this.Type = Type;
    }
}

export function Parameter$reflection() {
    return record_type("Containers.TelecomOrder.Model.Parameter", [], Parameter, () => [["Name", string_type], ["Index", int32_type], ["Type", ParameterType$reflection()]]);
}

export class Action extends Record {
    constructor(Name, Description, Category, Date$, AddParameters, RemoveParameters) {
        super();
        this.Name = Name;
        this.Description = Description;
        this.Category = Category;
        this.Date = Date$;
        this.AddParameters = AddParameters;
        this.RemoveParameters = RemoveParameters;
    }
}

export function Action$reflection() {
    return record_type("Containers.TelecomOrder.Model.Action", [], Action, () => [["Name", string_type], ["Description", string_type], ["Category", string_type], ["Date", class_type("System.DateTime")], ["AddParameters", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Parameter$reflection()])], ["RemoveParameters", option_type(class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Parameter$reflection()]))]]);
}

export function toActionMap(operations) {
    return ofList(map((o_2) => {
        let operation, getParameter;
        return [o_2.Name, (operation = o_2, (getParameter = ((param) => {
            let validValuesOpt, validValues, tupledArg, keyValueMap, matchValue;
            return new Parameter(param.Name, param.ParameterIndex, (validValuesOpt = param.ValidValues, (validValuesOpt != null) ? ((validValues = validValuesOpt, (tupledArg = ((keyValueMap = ofList(map((v) => [v.Value, v.Key], validValues)), [(matchValue = tryHead(validValues), (matchValue == null) ? "" : matchValue.Value), keyValueMap])), new ParameterType(2, tupledArg[0], tupledArg[1])))) : (new ParameterType(1, ""))));
        }), new Action(operation.Name, operation.Description, operation.Category, now(), ofList(map((o) => [o.Name, getParameter(o)], operation.AddParameters)), map_1((removeParameters) => ofList(map((o_1) => [o_1.Name, getParameter(o_1)], removeParameters)), operation.RemoveParameters))))];
    }, operations));
}

export function resetParameters(action) {
    return new Action(action.Name, action.Description, action.Category, action.Date, map_2((_arg, param) => {
        const matchValue = param.Type;
        switch (matchValue.tag) {
            case 1: {
                return new Parameter(param.Name, param.Index, new ParameterType(1, ""));
            }
            case 2: {
                return new Parameter(param.Name, param.Index, new ParameterType(2, "", matchValue.fields[1]));
            }
            default: {
                return new Parameter(param.Name, param.Index, new ParameterType(0, false));
            }
        }
    }, action.AddParameters), action.RemoveParameters);
}

export class CreateOrderDTO extends Record {
    constructor(contract_number, is_add, number, orderDate, parameters) {
        super();
        this.contract_number = (contract_number | 0);
        this.is_add = is_add;
        this.number = number;
        this.orderDate = orderDate;
        this.parameters = parameters;
    }
}

export function CreateOrderDTO$reflection() {
    return record_type("Containers.TelecomOrder.Model.CreateOrderDTO", [], CreateOrderDTO, () => [["contract_number", int32_type], ["is_add", bool_type], ["number", string_type], ["orderDate", string_type], ["parameters", list_type(string_type)]]);
}

export function getCreateOrderDTO(contractNr, number, action, isAdd) {
    const parameters = map((tupledArg_1) => {
        const matchValue = tupledArg_1[1].Type;
        switch (matchValue.tag) {
            case 1: {
                return matchValue.fields[0];
            }
            case 2: {
                return matchValue.fields[0];
            }
            default: {
                return toString(matchValue.fields[0]);
            }
        }
    }, sortBy((tupledArg) => tupledArg[1].Index, toList(defaultArg(isAdd ? action.AddParameters : action.RemoveParameters, empty())), {
        Compare: comparePrimitives,
    }));
    return new CreateOrderDTO(contractNr, isAdd, number, DateTimeExtensions_toIso8601(action.Date), parameters);
}

export class OperationStatusDTO extends Record {
    constructor(Operation, StatusJson) {
        super();
        this.Operation = Operation;
        this.StatusJson = StatusJson;
    }
}

export function OperationStatusDTO$reflection() {
    return record_type("Containers.TelecomOrder.Model.OperationStatusDTO", [], OperationStatusDTO, () => [["Operation", string_type], ["StatusJson", Json$reflection()]]);
}

